import { grapesjs } from "grapesjs";
import { getSubscriptions } from "../components/Subscriptions";
import { getSliders } from "../components/Slider";
import handleThankYou from "../components/ThankYou";
import {
  addScript,
  addStyle,
  hideLoading,
  tempRouting,
  formatUrl,
  showLoading,
  showAlert,
} from "../utils/domHelper";
import { getVideoPlayer } from "../components/VideoPlayer";
import { getAudioPlayer } from "../components/AudioPlayer";
import { getBannerSlider } from "../components/BannerSlider/entertainment";
import { getBannerSliderPlayTV } from "../components/BannerSlider/playtv";
import { getVideoTabs } from "../components/VideoTabs";
import { watchLive } from "../components/WatchLive";
import { getCategorySeriesGrid } from "../components/CategorySeriesGrid";
import { getCategories } from "../components/Categories";
import { getPublishers } from "../components/Publishers";

import CheckoutFormHandler, {
  completeCheckout,
} from "../components/Form/CheckoutForm";
import LoginFormHandler from "../components/Form/LoginForm";
import SignUpFormHandler from "../components/Form/SignUpForm";
import {singupPlansField,
        signupSetupPayment,
        startCustomPaypalFlow } from "../components/Form/SignUpForm";
import { getGatewayActive, getSubscriptionPlans, purchaseSubscription, completeSubscription3ds, loadStripeJs } from "../services/paymentService";

import { getFeaturedBanner } from "../components/FeaturedBanner";
import { getVODCategories } from "../components/VODCategories";
import { getVODCategoriesSlider } from "../components/VODCategoriesSlider";
import { getVODCategorySeries } from "../components/VODCategorySeries";
import { getLatestVideos } from "../components/LatestVideo";
import { renderChannelLive } from "../components/ChannelLive";
import { getGalleryCategory } from "../components/GalleryCategory";
import { getAudioCategories } from "../components/AudioCategories";
import { getAODCategorySeries } from "../components/AudioCategorySeries";
import { getChannelSliders } from "../components/Slider/Channel";
import { registerCancelCheckoutOrder } from "../components/PPV";
import { searchMedia } from "../components/SearchMedia";
import { getAudioCategoriesSlider } from "../components/AudioCategoriesSlider";
import { renderPPVEvent } from "../components/PPVEvent";
import { embeddedStream } from "../components/EmbeddedStream";
import {
  isSitePaymentOnly,
  isPaymentOnlyPage,
  getCurrentPageName,
  applyPaymentOnlyStyles,
} from "../utils/paymentOnlyMode";

const registerDOMEvent = () => {
  registerCancelCheckoutOrder();
  // Clean socket
  window.addEventListener("unload", function () {
    if (
      window.activeChannelSocket &&
      window.activeChannelSocket.readyState == WebSocket.OPEN
    ) {
      window.activeChannelSocket.close();
      clearInterval(window.retrivePlaying);
    }
  });
};

const initFormIO = async ({ baseUrl, settings, uuid }) => {
  const apiKey = settings.apiKey;
  const formContentWrapper = document.getElementsByClassName(
    "form-content-wrapper"
  );

  const getFormCallback = ({ callbackData, formName, settings, baseUrl }) => {
    if (formName === "signIn") {
      return async () =>
        LoginFormHandler(baseUrl, settings.tenantId, callbackData);
    }
    if (formName === "signUp") {
      return async () =>
        SignUpFormHandler(baseUrl, apiKey, callbackData);
    }
    if (formName === "billing") {
      const selfData = callbackData;
      return async () => {
        const resJson = await completeCheckout(
          selfData._data,
          settings,
          baseUrl
        );
        if (resJson.status === "F") {
          callbackData.emit("submitDone", "");
          return;
        }
        const msg = resJson.message || {};
        if (msg.requires_action && msg.client_secret && msg.subscription_id) {
          const activeGW = await getGatewayActive(baseUrl, apiKey);
          if (activeGW?.gateway_provider !== 2) {
            callbackData.emit("submitDone", "");
            showAlert("3D Secure is not available for this payment method.");
            return;
          }
          const stripeApiKey = activeGW.credential_information.publishable_api_key;
          const stripe = await loadStripeJs(stripeApiKey);
          if (!stripe) {
            callbackData.emit("submitDone", "");
            showAlert("Payment form could not be loaded. Please try again.");
            return;
          }
          const { error } = await stripe.confirmCardPayment(msg.client_secret);
          if (error) {
            callbackData.emit("submitDone", "");
            showAlert(error.message || "Payment could not be completed.");
            return;
          }
          const completeRes = await completeSubscription3ds(baseUrl, apiKey, msg.subscription_id);
          if (completeRes?.error) {
            callbackData.emit("submitDone", "");
            showAlert(completeRes.error || "Subscription could not be completed.");
            return;
          }
        }
        let searchParams = new URLSearchParams(window.location.search);
        const redirectTo = searchParams.get("redirect_to");
        window.location = formatUrl(
          `/thank-you${redirectTo ? `?redirect_to=${redirectTo}` : ""}`
        );
        callbackData.emit("submitDone", "");
      };
    }
  };

  if (formContentWrapper && formContentWrapper.length) {
    try {
      showLoading();
      const formData = await fetch(`${baseUrl}/block/list/`, {
        method: "GET",
        headers: {
          Authorization: `Tenant-Key ${settings.apiKey}`,
        },
      });
      const jsonForms = await formData.json();
      await handleThankYou(settings, baseUrl);

      Array.from(formContentWrapper).forEach(async (fw) => {
        const formName = fw.attributes.formtype.value;
        const currentForm = jsonForms.find((el) => el.name === formName);
        let components = currentForm.components.form;
        let subs_component = null;
        let plans = null;

        if (formName === 'Sign Up') {
          let urlSearchParams = new URLSearchParams(window.location.search);
          let params = Object.fromEntries(urlSearchParams.entries());
          let channelId = 'empty';

          if (params.channelId !== undefined) {
            channelId = params.channelId;
          }

          plans = await getSubscriptionPlans(baseUrl, settings.apiKey, channelId, {});
          subs_component = await singupPlansField(baseUrl, settings.apiKey, channelId);

          // Always insert plan component(s) first, before the submit button
          const submitIndex = components.findIndex(c => c.type === 'button');
          if (Array.isArray(subs_component)) {
            components.splice(submitIndex, 0, ...subs_component);
          } else if (subs_component) {
            components.splice(submitIndex, 0, subs_component);
          }
        }

        // console.log(currentForm);
        Formio.createForm(
          fw,
          {
            components: components,
          },
          {
            noAlerts: true,
          }
        )
        .then(async function (form) {
          const activeGW = await getGatewayActive(baseUrl, settings.apiKey);
          if (formName == 'Sign Up'){
            $('.formio-component-submit').append(`
              <p style="margin-top: 30px;text-align: center;">Already have account? <a href="/sign-in" style="font-weight: bold;text-decoration: underline;font-size: 18px;">Login</a></p>
            `);
            signupSetupPayment(baseUrl, settings.apiKey);
          }
          $('head').append(`
            <style id="hide-autocomplete-css">
            .formio-select-autocomplete-input {
              height: 0 !important;
              padding: 0 !important;
              margin: 0 !important;
              border: none !important;
              visibility: hidden !important;
              position: absolute !important;
            }
            </style>
            `);

          const isSignup = formName === "Sign Up";
          const isBilling = currentForm.key === "billing";
          const isStripe = activeGW?.gateway_provider === 2;
          const isPayPal = activeGW?.gateway_provider === 1;

          const defaultCallback = getFormCallback({
            callbackData: form,
            formName: isSignup ? "signUp" : currentForm.key,
            settings: settings.generalSettings,
            baseUrl,
            uuid,
          });

          if (isSignup && !isBilling && isStripe) {
            form.on("submit", defaultCallback);
          } else if (isPayPal) {
            form.on("submit", async (submission) => {
              if (!isSignup) return;

              const { email, password, userName, coupon } = submission.data;
              const planId = form.submission.data.plan;
              const selectedPlan = Array.isArray(plans) ? plans.find(p => p.uuid === planId) : null;

              const payload = {
                subscriptionId: null,
                email,
                first_name: userName,
                last_name: userName,
                password,
                uuid: selectedPlan?.uuid || null,
                subscriptionDetails: { status: "FREE" },
                coupon_code: coupon || null,
              };

              if (!selectedPlan || selectedPlan.is_free) {
                const response = await purchaseSubscription(baseUrl, settings.apiKey, JSON.stringify(payload));

                if (response?.credentials) {
                  localStorage.setItem("loginToken", JSON.stringify(response.credentials));

                  await getFormCallback({
                    callbackData: form,
                    formName: "signIn",
                    settings: settings.generalSettings,
                    baseUrl,
                    uuid,
                  })();
                } else {
                  showAlert("Subscription error. Please try again.");
                }

                return;
              }

              const { client_id, client_secret } = activeGW.credential_information;

              await startCustomPaypalFlow({
                baseUrl,
                apiKey: settings.apiKey,
                client_id,
                client_secret,
                plan: selectedPlan,
                firstName: userName,
                lastName: userName,
                email,
                password,
                onLogin: getFormCallback({
                  callbackData: form,
                  formName: "signIn",
                  settings: settings.generalSettings,
                  baseUrl,
                  uuid,
                }),
              });
            });
          } else {
            form.on("submit", defaultCallback);
          }
          if (isBilling) {
            CheckoutFormHandler(settings, form, baseUrl);
          }
        })
        .finally(() => {
          hideLoading();
        });

        $('head').append($('<style>').text(`.choices__list {color: black} #stripe-card-element{background: white;padding: 12px;border-radius: 4px;}`));
      });
    } catch (err) {
      hideLoading();
    }
  }
};

export default function App(data = {}) {
  const { configs, settings, base_url: baseUrl, uuid } = data;
  const pageConfig = configs.content;
  const paymentOnlyMode = isSitePaymentOnly(settings);
  const paymentOnlyPage = isPaymentOnlyPage(getCurrentPageName());
  
  // Handle mobile auth params early (for logout and auto-login)
  const apiKey = settings.apiKey;
  const tenantId = settings?.generalSettings?.tenantId;
  if (apiKey && tenantId && baseUrl) {
    import('../utils/authHelper').then(({ handleMobileAuthParams }) => {
      handleMobileAuthParams(baseUrl, apiKey, tenantId).catch(err => {
        console.error('[App] Failed to handle mobile auth params:', err);
      });
    });
  }
  
  if (window.location.pathname.endsWith("/sign-up.html")) {
    const tenantId = settings?.generalSettings?.tenantId || "unknown";
    const srcUrl = window.location.origin;
    const redirectUrl = `https://signup-form.tvstartupcms.com/?tenant_id=${encodeURIComponent(tenantId)}&src_url=${encodeURIComponent(srcUrl)}`;
    window.location.replace(redirectUrl);
    return;
  }else if (window.location.pathname.endsWith("/sign-in.html")) {
    const tenantId = settings?.generalSettings?.tenantId || "unknown";
    const srcUrl = window.location.origin;
    const currentParams = new URLSearchParams(window.location.search);

    currentParams.set("tenant_id", tenantId);
    currentParams.set("src_url", srcUrl);

    const redirectUrl = `https://signin-form.tvstartupcms.com/?${currentParams.toString()}`;
    window.location.replace(redirectUrl);
    return;
  }
  // eslint-disable-next-line no-undef
  const editor = grapesjs.init({
    container: "#gjs",
    components: pageConfig["gjs-components"],
    style: pageConfig["gjs-styles"],
    log: ["error"],
  });

  const template = document.createElement("template");
  template.innerHTML = `${editor.getHtml()}`;
  localStorage.setItem("template_uuid", uuid);

  // Remove later when devops fix routing
  tempRouting(uuid);

  if (paymentOnlyMode) {
    addStyle(applyPaymentOnlyStyles(paymentOnlyPage));
  }

  // eslint-disable-next-line no-undef
  $(document).ready(async function () {
    hideLoading();
    new WOW().init({
      boxClass: "wow",
      headless: true,
      animateClass: "animated",
      offset: 0,
      mobile: true,
      live: true,
    });
    // add hidden for class container - fix scroll animation
    $("body > div").css("overflow-x", "hidden");
    $(".video-tabs").hide();
    addScript(pageConfig["gjs-scripts"]);

    if (!paymentOnlyMode) {
      await getBannerSlider(settings, baseUrl, uuid);
      await getBannerSliderPlayTV(settings, baseUrl, uuid);
      await getSliders(settings, baseUrl, uuid);
    }

    await getVideoPlayer(settings, baseUrl);
    await getAudioPlayer(settings, baseUrl);

    if (!paymentOnlyMode || paymentOnlyPage) {
      await getSubscriptions(settings, baseUrl, uuid);
    }

    await handleThankYou(settings, baseUrl, uuid);

    if (!paymentOnlyMode) {
      await getVideoTabs(settings, baseUrl, uuid);
      await watchLive(settings, baseUrl, uuid);
      await getCategorySeriesGrid(null, settings, baseUrl, uuid);
      await getCategories(null, settings, baseUrl, uuid);
      await getPublishers(settings, baseUrl);
      await getVODCategories(null, settings, baseUrl, uuid);
      await getVODCategoriesSlider(null, settings, baseUrl, uuid);
      await getAudioCategories(null, settings, baseUrl, uuid);
      await getAudioCategoriesSlider(null, settings, baseUrl, uuid);
      await getAODCategorySeries(null, settings, baseUrl, uuid);
      await getVODCategorySeries(null, settings, baseUrl, uuid);
      await getFeaturedBanner(settings, baseUrl, uuid);
      await getLatestVideos(settings, baseUrl, uuid);
      await renderChannelLive(settings, baseUrl, uuid);
      await getGalleryCategory(settings, baseUrl, uuid);
      await getChannelSliders(settings, baseUrl, uuid);
      await searchMedia(settings, baseUrl, uuid);
      await embeddedStream(settings, baseUrl, uuid);
    }

    if (!paymentOnlyMode || paymentOnlyPage) {
      await renderPPVEvent(settings, baseUrl);
    }

    // DOM registered
    registerDOMEvent();

    if (!paymentOnlyMode || paymentOnlyPage) {
      await initFormIO({ baseUrl, settings, uuid });
    }
  });

  addStyle(editor.getCss());
  // Return a new node from template
  return template.content.cloneNode(true);
}

document.addEventListener("DOMContentLoaded", () => {
  const urlParams = new URLSearchParams(window.location.search);
  const encodedToken = urlParams.get("loginToken");

  if (!encodedToken) return;

  try {
    const token = JSON.parse(atob(decodeURIComponent(encodedToken)));
    localStorage.setItem("loginToken", JSON.stringify(token));

    // Optional: redirect or trigger auto-login
    window.location.href = "/";
  } catch (err) {
    console.error("Invalid loginToken in URL:", err);
  }

  // Optional: clean the URL
  window.history.replaceState({}, document.title, window.location.pathname);
});
